export default __webpack_public_path__ + "static/media/homedepot.8c09e3ad.png";